import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Chart } from 'node_modules/chart.js';
import { StoreService } from 'src/app/store.service';
import { DealerService } from '../../dealer.service';
import * as moment from 'moment';
import { NavigationExtras, Router } from '@angular/router';
import {
  ApexAnnotations,
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexMarkers,
  ApexNonAxisChartSeries,
  ApexOptions,
  ApexPlotOptions,
  ApexResponsive,
  ApexStroke,
  ApexTheme,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexYAxis,
  ApexTooltip,
} from 'ng-apexcharts';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { AiInsightSection, AiSectionConfig, parseAiInsightSections } from 'src/app/core/ai-summary-parser';
import { TranslationService } from 'src/app/core/translation.service';

let primary = '#2152FF';

export type ChartOptions = {
  series?: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart?: ApexChart;
  xaxis?: ApexXAxis | ApexXAxis[];
  stroke?: ApexStroke;
  tooltip?: ApexTooltip;
  dataLabels?: ApexDataLabels;
  yaxis?: ApexYAxis | ApexYAxis[];
  legend?: ApexLegend;
  labels?: string[];
  plotOptions?: ApexPlotOptions;
  fill?: ApexFill;
  responsive?: ApexResponsive[];
  pieseries?: ApexNonAxisChartSeries;
  title?: ApexTitleSubtitle;
  theme?: ApexTheme;
  colors?: string[];
  markers?: ApexMarkers;
  annotations?: ApexAnnotations;
  grid?: ApexGrid;
  options?: ApexOptions;
  subtitle?: ApexTitleSubtitle;
};

/**
 * The prompt asks for these English headings word for word, in every dashboard
 * language, and the card titles are translated here. The translated phrases are
 * only a fallback for when the model translates a heading anyway.
 */
const AI_SUMMARY_SECTIONS: AiSectionConfig[] = [
  {
    theme: 'overview',
    title: 'Executive Overview',
    icon: 'fi-rr-chart-pie-alt',
    phrases: ['executive overview', 'overview', '整体概览', '执行概览', '概览', '整體概覽', '執行概覽', '概覽', 'ikhtisar eksekutif', 'ikhtisar'],
  },
  {
    theme: 'performers',
    title: 'Top Converting Links & Campaigns',
    icon: 'fi-rr-link-alt',
    phrases: ['top converting links & campaigns', 'top converting', 'popular links', 'top performers', 'campaigns', '转化最佳', '轉換最佳', '热门链接', '熱門連結', 'tautan terbaik', 'tautan populer'],
  },
  {
    theme: 'friction',
    title: 'Drop-Offs & Friction Points',
    icon: 'fi-rr-exclamation',
    phrases: ['drop-offs & friction points', 'drop-offs', 'drop-off points', 'drop offs', 'friction', 'abandoned', 'bottlenecks', '流失点', '流失點', '阻力', 'titik hambatan', 'hambatan'],
  },
  {
    theme: 'recommendations',
    title: 'Actionable Growth Recommendations',
    icon: 'fi-rr-bulb',
    phrases: ['actionable growth recommendations', 'growth recommendations', 'actionable recommendations', 'recommendations', 'action plan', 'key takeaways', '增长建议', '成長建議', '行动建议', '行動建議', '建议', '建議', 'rekomendasi'],
  },
];

@Component({
  selector: 'app-express-checkout-dashboard',
  templateUrl: './express-checkout-dashboard.component.html',
  styleUrls: ['./express-checkout-dashboard.component.scss'],
})
export class ExpressCheckoutDashboardComponent implements OnInit {
  performingData: any = {
    daily: [],
    today: [],
    yesterday: [],
    curr_month: [],
    last_month: [],
    curr_year: [],
    last_year: [],
    chart: null,
  };

  date = new Date();

  bearer;
  store_id;
  countryList;
  countryName = 'Select Country';
  selectedCountryCode = '';
  countryFlag = '';
  orderSummary = [];
  totalSale = 0;

  totalCreatedLink;
  /** Paid express checkout orders, all time (checkout_link/rate success_order); only the AI summary uses it. */
  paidLinkOrders;
  abandonedOrders;
  coversionRate;
  expressCheckoutData;
  expressCheckoutDate;
  startDate;
  endDate;
  myDate = new Date();
  day;
  month;
  year;
  currentDate;
  fromDate: NgbDate;
  currentMonthActive;
  todayActive;
  last14DaysActive;
  last30DaysActive;
  last14day;
  last14;
  productCountry;
  productCountryList;
  productFilterCountryList;
  filteredProductCountry;
  popularLink;

  /** AI Assistant / Summary state */
  isGeneratingAiSummary = false;
  aiSummaryContent = '';
  aiSummaryError: string | null = null;
  showAiSummaryCard = false;
  isCopied = false;
  enableAIAssistant = false;
  /** Credits one AI summary costs, from the backend (AI_REPORT_SUMMARY_CREDIT); null until loaded or when not charged. */
  aiTokenCost: number | null = null;
  /** Purpose of the clicked AI button (its data-ai-purpose), sent to Mixpanel as ai_purpose. */
  aiPurpose = 'generate summary';
  parsedSections: AiInsightSection[] = [];
  private copyTimeout: any;

  exportType = [
    // { display: 'Csv', value: 'csv' },
    { display: 'Excel', value: 'excel' },
    // { display: 'PDF',  value: 'pdf'},
  ];

  DATE_FILTER_OPTIONS = [
    { display: 'Current Month', value: 'CurrentMonth' },
    { display: 'Today', value: 'Today' },
    { display: 'Last 14 Days', value: 'Last14Days' },
    { display: 'Last 30 Days', value: 'Last30Days' },
  ];
  selectedDateFilter = this.DATE_FILTER_OPTIONS[0];
  searchTerm: string = '';
  isExporting: boolean = false;

  constructor(
    private dealerService: DealerService,
    private svc: StoreService,
    private router: Router,
    public utils: UtilitiesService,
    private sanitizer: DomSanitizer,
    private translationService: TranslationService
  ) {
  }

  selectDateFilter(option: { display: string; value: string }) {
    this.selectedDateFilter = option;
    this.toggleNav(option.value);
  }

  getFilteredProducts() {
    if (!this.productFilterCountryList) return [];
    if (!this.searchTerm || !this.searchTerm.trim()) return this.productFilterCountryList;
    const term = this.searchTerm.toLowerCase().trim();
    return this.productFilterCountryList.filter((p: any) =>
      p && p.product_name && p.product_name.toLowerCase().includes(term)
    );
  }

  getFilteredLinks() {
    if (!this.popularLink) return [];
    if (!this.searchTerm || !this.searchTerm.trim()) return this.popularLink;
    const term = this.searchTerm.toLowerCase().trim();
    return this.popularLink.filter((l: any) =>
      l && l.name && l.name.toLowerCase().includes(term)
    );
  }

  clearSearch() {
    this.searchTerm = '';
  }

  ngOnInit(): void {
    this.store_id = localStorage.getItem('store_id');
    this.bearer = localStorage.getItem('bearer');
    this.day = this.myDate.getDate();
    this.month = this.myDate.getMonth(); // Be careful! January is 0, not 1
    this.year = this.myDate.getFullYear();
    this.currentDate = this.year + '-' + (this.month + 1) + '-' + this.day;
    // this.startDate = this.year + '-' + (this.month + 1) + '-' + 1;
    // this.endDate = this.currentDate;

    this.loadAiCreditState();
    this.getExpressDashboardRate();
    this.getExpressDashboardPopular();

    setTimeout(() => {
      this.toggleNav("Last30Days");
    }, 1000);
  }

  seeMoreClick(){
    this.router.navigate(['/dashboard/express-checkout']);
  }

  callgetCountry(){
    this.svc.getCountry(this.bearer).subscribe((res) => {
      res['data'].forEach((value) => {
        value.country_name = value.country_name.split('-').pop().trim();
      });
      this.countryList = res['data'];
      this.filteredProductCountry = this.countryList.filter(item => this.productCountry.includes(item.country_code));
      this.filteredProductCountry.forEach((item) => {
        if (item['country_flag'] === '') {
          let flag = item['country_code'].substr(-2).toLowerCase();
          item['country_flag'] =
            'https://cdn.estore5s.com/asset/flags/' + flag + '.png';
        } else {
          item['country_flag'] = item['country_flag'];
        }
      });
      let defaultCountry = this.filteredProductCountry.find((index) => {
        if (parseInt(index['default']) === 1) {
          return index;
        }
      });
      if(defaultCountry != undefined){
        this.changeCountry(defaultCountry.country_code);
      }else{
        this.changeCountry(this.filteredProductCountry[0]['country_code']);
      }
      this.countryName =
        defaultCountry['country_name'] || this.filteredProductCountry[0]['country_name'];
      this.countryFlag =
        defaultCountry['country_flag'] || this.filteredProductCountry[0]['country_flag'];
      let country = this.filteredProductCountry.find((index) => {
        return index.country_name === this.countryName;
      });
    });

  }

  updateProductListFilter(countryCode){
    this.productFilterCountryList = this.productCountryList[countryCode][0];
  }

  changeCountry(countryCode) {
    let country = this.filteredProductCountry.find((index) => {
      return index.country_code == countryCode;
    });
    this.selectedCountryCode = country.country_code;
    this.countryFlag = country.country_flag;
    this.countryName = country.country_name;
    this.updateProductListFilter(countryCode);
    // this.getReport(country);
  }

  getCountryFlag(countryCode) {
    let flag = countryCode.length > 2 ? countryCode.substr(-2) : countryCode;
    return (
      'https://cdn.estore5s.com/asset/flags/' + flag.toLowerCase() + '.png'
    );
  }

  public apxchart: ChartOptions = {
    chart: {
      height: 280,
      type: 'area',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 5,
      colors: ['#2152FF'],
    },
    fill: {
      // colors: ['#2152FF','#21D4FD'],
      type: 'gradient',
      gradient: {
        shade: 'dark',
        gradientToColors: ['#21D4FD'],
        type: 'vertical',
        shadeIntensity: 0.4,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.4,
        stops: [0, 100, 100, 100],
      },
    },
    series: [
      {
        name: '',
        data: [],
      },
    ],
    title: {
      text: '',
      align: 'left',
    },
    colors: [primary],
    labels: [],
    xaxis: {
      type: 'category',
    },
    yaxis: {
      opposite: false,
      min: 0,
      labels: {
        formatter: function (val) {
          return val.toFixed(0);
        },
      },
    },
  };

  getAnalysisData() {
    this.svc.getExpressDashboardAnalysisData(
        this.bearer,
        this.store_id,
        this.startDate,
        this.endDate
      )
      .subscribe((res) => {
        const ecData = Object.keys(res['data'])
          .filter((key) => res['data'][key] !== 0)
          .reduce((result, key) => {
            result[key] = res['data'][key];
            return result;
          }, {});
        this.expressCheckoutDate = Object.keys(ecData);
        this.expressCheckoutData = Object.values(ecData);

        this.loadPerformingChart();
      });
  }

  getExpressDashboardPopular() {
      this.svc
          .getExpressDashboardPopular(this.bearer, this.store_id)
          .subscribe((res) => {
              this.productCountry = Object.keys(res['data']['product']);
              this.productCountryList = res['data']['product'];
              this.popularLink = res['data']['link']

              this.callgetCountry();
          });
  }

  getExpressDashboardRate() {
      this.svc
          .getExpressDashboardRate(this.bearer, this.store_id)
          .subscribe((res) => {
              this.paidLinkOrders = res['data']['success_order'];
              this.abandonedOrders = res['data']['pending_order'];
              this.coversionRate = parseFloat(res['data']['rate'].toFixed(2));
              this.totalCreatedLink = res['data']['link_created'];
          });
  }

  toggleNav(param: string) {
    const navStateMap = {
      CurrentMonth: 0,
      Today: 1,
      Last14Days: 2,
      Last30Days: 3,
    };
    const navStates = ['false', 'false', 'false', 'false'];
    const selectedIndex = navStateMap[param];
    if (selectedIndex !== undefined) {
      navStates[selectedIndex] = 'nav-active';

    switch (param) {
      case "CurrentMonth":
        this.startDate = `${this.year}-${this.month + 1}-01`;
        this.endDate = this.currentDate;
        break;
      case "Today":
        this.startDate = this.currentDate;
        this.endDate = this.currentDate;
        break;
      case "Last14Days":
        this.last14 = new Date(this.myDate);
        this.last14.setDate(this.last14.getDate() - 14);
        this.startDate = `${this.last14.getFullYear()}-${this.last14.getMonth() + 1}-${this.last14.getDate()}`;
        this.endDate = this.currentDate;
        break;
      case "Last30Days":
        this.year = this.myDate.getFullYear();
        this.startDate = `${this.year}-${this.month}-${this.day}`;
        this.endDate = this.currentDate;
        break;
    }
  }

    this.currentMonthActive = navStates[0];
    this.todayActive = navStates[1];
    this.last14DaysActive = navStates[2];
    this.last30DaysActive = navStates[3];

    const matched = this.DATE_FILTER_OPTIONS.find(o => o.value === param);
    if (matched) {
      this.selectedDateFilter = matched;
    }

    this.getAnalysisData();
  }

  loadPerformingChart() {
    let value = this.expressCheckoutData;
    let label = this.expressCheckoutDate;
    let numberoflink = this.utils.translate('Number of Link');

    var performanceChartData = this.apxchart;

    this.performingData.chart = performanceChartData;
    performanceChartData.series = [
      {
        name: '',
        data: value,
      },
    ];

    performanceChartData.labels = label;

    performanceChartData.tooltip = {
      followCursor: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          series[seriesIndex][dataPointIndex] +
          '<br>' +
          "<span style='font-size:9px'>" +
          numberoflink +
          '</span>' +
          '</div>'
        );
      },
      x: {
        show: false,
      },
    };
  }

  numFormat = {
    y: {
      formatter: function (value) {
        let num = value.toFixed(0);
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
    },
  };


  countryCode2Len(countryCode) {
    return countryCode?.trim()?.toLowerCase()?.substr(-2);
  }

  download(type){
    this.isExporting = true;
    let param = {
      store_id: this.store_id,
      type : type,
    }
    this.svc.downloadRequest(this.bearer,'/checkout_link/export_dashboard',param);
    setTimeout(() => {
      this.isExporting = false;
    }, 2000);
  }

  /** Strips the protocol so the path stays readable on a narrow screen. */
  displayUrl(url?: string): string {
    if (!url) return '-';
    return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }

  /** Loads the AI Summary price (from the backend config) and whether the button can be used. */
  loadAiCreditState(): void {
    this.dealerService.getAiCreditState('AI_REPORT_SUMMARY_CREDIT').subscribe(({ enabled, tokenCost }) => {
      this.enableAIAssistant = enabled;
      this.aiTokenCost = tokenCost;
    });
  }

  /** Prepares structured report data for the AI prompt. */
  /**
   * Prepares the report data for the AI prompt (GENERATE_EXPRESS_CHECKOUT_REPORT_SUMMARY).
   * The rate, order and link totals and the popular lists come from endpoints that take no
   * dates, so they are all time; only the links-created trend follows the date filter. The
   * payload says which is which so the AI does not present all-time totals as this month's.
   * Every derived figure is worked out here so the model only explains numbers.
   * The labels are referenced by the prompt template.
   */
  prepareReportSummaryPayload(): string {
    const num = (v: any) => {
      const n = parseFloat(`${v ?? 0}`);
      return isFinite(n) ? n : 0;
    };
    const count = (v: number) => Math.round(v ?? 0).toLocaleString('en-US');
    const pct = (v: number) => `${(v ?? 0).toFixed(2)}%`;
    const share = (part: number, whole: number) => (whole > 0 ? `${Math.round((part / whole) * 100)}%` : '0%');

    const linksCreated = num(this.totalCreatedLink);
    const paid = num(this.paidLinkOrders);
    const unpaid = num(this.abandonedOrders);
    const started = paid + unpaid;
    const rate = num(this.coversionRate);
    const completion = started > 0 ? (paid / started) * 100 : 0;

    // Links-created trend for the selected dates (zero days are dropped when loaded)
    const trendDates: string[] = this.expressCheckoutDate || [];
    const trendValues: number[] = (this.expressCheckoutData || []).map((v: any) => num(v));
    const periodLinks = trendValues.reduce((sum, v) => sum + v, 0);
    const busiestIndex = trendValues.length ? trendValues.indexOf(Math.max(...trendValues)) : -1;
    const busiestDay = busiestIndex >= 0 ? `${trendDates[busiestIndex]} (${count(trendValues[busiestIndex])} links)` : 'none';
    const dateRange = this.startDate && this.endDate ? `${this.startDate} to ${this.endDate}` : 'not set';

    const links: any[] = this.popularLink || [];
    const topLinkOrders = links.reduce((sum, l) => sum + num(l.quantity), 0);
    const linkLines = links.slice(0, 5).map((l: any, i: number) =>
      `${i + 1}. Link: ${l.name || 'Untitled link'}${l.url ? ` | URL: ${l.url}` : ''}`
      // Popular links and the rate endpoint count orders with slightly different filters, so cap the share
      + ` | Paid orders: ${count(num(l.quantity))} (${share(Math.min(num(l.quantity), paid), paid)} of all paid express checkout orders)`
      + ` | Country: ${l.country_code || 'not set'}${l.type ? ` | Type: ${l.type}` : ''}`
    );

    const country = this.selectedCountryCode ? this.countryName : 'all countries';
    const productLines = (this.productFilterCountryList || []).slice(0, 5).map((p: any, i: number) =>
      `${i + 1}. Product: ${p.product_name} | Orders containing it: ${count(num(p.quantity))}`
    );

    const lines = [
      'ALL-TIME TOTALS (not limited to the selected dates)',
      `Express checkout links created: ${count(linksCreated)}`,
      `Paid orders from links: ${count(paid)}`,
      `Unpaid (abandoned) checkouts: ${count(unpaid)}`,
      `Link conversion rate: ${pct(rate)} (paid orders per link created)`,
      `Checkout completion rate: ${pct(completion)} (paid orders out of all checkouts started)`,
      `Unpaid share of checkouts started: ${share(unpaid, started)}`,
      `Share of paid orders from the top 5 links: ${share(Math.min(topLinkOrders, paid), paid)}`,
      '',
      `SELECTED DATES: ${this.selectedDateFilter?.display || 'Current Month'} (${dateRange})`,
      `Links created in these dates: ${count(periodLinks)}`,
      `Days with new links: ${count(trendValues.length)}`,
      `Busiest day: ${busiestDay}`,
    ];

    return [
      lines.join('\n'),
      `TOP LINKS BY PAID ORDERS (all time)\n${linkLines.length ? linkLines.join('\n') : 'None - no paid orders yet'}`,
      `MOST ORDERED PRODUCTS (${country}, all time)\n${productLines.length ? productLines.join('\n') : 'None'}`,
    ].join('\n\n');
  }

  /** Sends the Mixpanel AI Generate event; ai_purpose comes from the clicked button's data-ai-purpose. */
  private trackAiGenerate(event: 'AI Generate Success' | 'AI Generate Fail', errorResponse?: string): void {
    this.svc.trackAiGenerateEvent(event, {
      aiPurpose: this.aiPurpose,
      storeId: this.store_id,
      token: this.aiTokenCost || 0,
      errorResponse,
    });
  }

  /** Triggers the AI Assistant to analyze and summarize the report. */
  generateAiSummary(event?: Event): void {
    if (this.isGeneratingAiSummary) return;
    this.aiPurpose = (event?.currentTarget as HTMLElement)?.dataset?.aiPurpose || this.aiPurpose;

    this.isGeneratingAiSummary = true;
    this.aiSummaryError = null;
    this.showAiSummaryCard = true;
    this.isCopied = false;

    const reportData = this.prepareReportSummaryPayload();

    const params: any = {
      type: 'GENERATE_EXPRESS_CHECKOUT_REPORT_SUMMARY',
      report_data: reportData,
      // Middleware writes the summary in this dashboard language; headings stay English for parseAiSummary()
      language_code: this.translationService.getLanguageCode(),
      desc: 'AI Express Checkout Report Summary Generation',
    };

    this.svc.getAIGeneratedContent(params).subscribe(
      (res: any) => {
        this.isGeneratingAiSummary = false;
        let content = res?.data;
        if (typeof content === 'object') {
          content = JSON.stringify(content, null, 2);
        }
        this.aiSummaryContent = content || 'No summary generated.';
        this.parseAiSummary();
        this.loadAiCreditState();
        this.trackAiGenerate('AI Generate Success');
      },
      (err: any) => {
        this.isGeneratingAiSummary = false;
        console.error('[express-checkout-dashboard] AI generation failed', err);
        const serverMsg =
          err?.error?.message ||
          err?.error?.data?.error ||
          err?.error?.data?.message ||
          err?.error?.error;
        const errorMsg =
          (typeof serverMsg === 'string' && serverMsg ? serverMsg : null) ||
          this.utils?.getErrorMessageWithRefId?.(
            err,
            'Unable to generate AI summary at this time. Please check your AI Assistant credits or try again.'
          ) ||
          'Unable to generate AI summary at this time. Please check your AI Assistant credits or try again.';
        this.aiSummaryError = errorMsg;
        this.trackAiGenerate('AI Generate Fail', errorMsg);
      }
    );
  }

  /** Parses raw AI text into clean, structured sections for modern card rendering. */
  parseAiSummary(): void {
    // splitNotes: "Label: 62% - what it means" renders the figure bold and the explanation regular
    this.parsedSections = parseAiInsightSections(this.aiSummaryContent, AI_SUMMARY_SECTIONS, { splitNotes: true });
  }

  /** Copies generated AI summary text to clipboard. */
  copyAiSummary(): void {
    if (!this.aiSummaryContent) return;
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(this.aiSummaryContent).then(() => {
        this.isCopied = true;
        this.utils?.notify?.showSuccess?.(
          'AI Summary has been copied to clipboard',
          'Copied!'
        );
        clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => {
          this.isCopied = false;
        }, 3000);
      });
    } else {
      this.utils?.copyToClipboard?.(this.aiSummaryContent, 'AI Summary');
    }
  }

  /** Closes/hides the AI summary card. */
  dismissAiSummary(): void {
    this.showAiSummaryCard = false;
  }
}
